import React from 'react';

// @ts-ignore
import { Button } from '@imgly/imgly-website-components';
import { MDXProvider } from '@mdx-js/react';
// @ts-ignore
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';

import { CallToAction } from '../CallToAction';
import { CodeBlock } from '../CodeBlock';
import { ContentIf } from '../ContentIf';
import { ContentSwitcher } from '../ContentSwitcher';
import { Disclaimer } from '../Disclaimer';
import { Grid } from '../Grid';
import { Grid3 } from '../Grid3';
import { GridItem } from '../GridItem';
import { InteractiveCodeBlock } from '../InteractiveCodeBlock';
import { InteractiveLanguage } from '../InteractiveLanguage';
import { InteractiveText } from '../InteractiveText';
import { Introduced } from '../Introduced';
import { KeyCapabilities } from '../KeyCapabilities';
import { LinkButton } from '../LinkButton';
import { LogoWall } from '../LogoWall';
import { MultiCodeBlock } from '../MultiCodeBlock';
import { ProductSwitch } from '../ProductSwitch';
import { Table } from '../Table';
import { VideoFrame } from '../VideoFrame';

import { CustomHeader } from './CustomHeader';
import { CustomImage } from './CustomImage';
import { CustomLink } from './CustomLink';
import { CustomParagraph } from './CustomParagraph';
import { CustomTable } from './CustomTable';
import { CustomTBody } from './CustomTBody';
import { CustomTD } from './CustomTD';
import { CustomTH } from './CustomTH';
import { CustomTHead } from './CustomTHead';
import { CustomTR } from './CustomTR';

/* eslint-disable react/display-name */
const createCustomHeading =
  (tag: string, anchor = true): React.FC =>
  ({ children, ...props }) =>
    (
      <CustomHeader tag={tag} anchor={anchor} {...props}>
        {children}
      </CustomHeader>
    );
/* eslint-enable react/display-name */

const Empty: React.FC = ({ children }) => children as React.ReactElement;

// Components added here can be directly use in the Markdown
// without importing from the package
const shortcodes = {
  MultiCodeBlock,
  VideoFrame,
  Disclaimer,
  Grid,
  Grid3,
  GridItem,
  ProductSwitch,
  InteractiveCodeBlock,
  InteractiveLanguage,
  InteractiveText,
  Introduced,
  ContentIf,
  ContentSwitcher,
  Button,
  LinkButton,
  Table,
  KeyCapabilities,
  CallToAction,
  LogoWall,
};

const components = {
  pre: Empty,
  code: CodeBlock,
  a: CustomLink,
  table: CustomTable,
  thead: CustomTHead,
  tbody: CustomTBody,
  th: CustomTH,
  td: CustomTD,
  tr: CustomTR,
  p: CustomParagraph,
  img: CustomImage,
  h1: createCustomHeading('h1', false),
  h2: createCustomHeading('h2'),
  h3: createCustomHeading('h3'),
  h4: createCustomHeading('h4'),
  h5: createCustomHeading('h5'),
  h6: createCustomHeading('h6'),
};

interface Props {
  body?: string;
}

export const CustomMDXRenderer: React.FC<Props> = ({ body }) => {
  if (!body) return null;

  return (
    <MDXProvider components={{ ...components, ...shortcodes }}>
      <MDXRenderer>{body}</MDXRenderer>
    </MDXProvider>
  );
};
